import { VIEON_REQUEST_SUBS_STATUS } from '@/view/pages/vieon-product-providers/utils/enum';

export const VIEON_REQUEST_SUBS_STATUS_NAME = Object.freeze({
  [VIEON_REQUEST_SUBS_STATUS.FAIL]: 'Lỗi hệ thống DDV hoặc đối tác thanh toán',
  [VIEON_REQUEST_SUBS_STATUS.SUCCESSFUL]: 'Thành công',
  [VIEON_REQUEST_SUBS_STATUS.PROCESSING]:
    'Hệ thống đang đợi khách hàng thanh toán',
  [VIEON_REQUEST_SUBS_STATUS.ERROR]: 'Lỗi hệ thống Vieon',
  [VIEON_REQUEST_SUBS_STATUS.CANCEL]: 'Khách hàng hủy khi đang giao dịch',
  [VIEON_REQUEST_SUBS_STATUS.REFUND]:
    'Yêu cầu hoàn tiền được duyệt',
  [VIEON_REQUEST_SUBS_STATUS.INVALID_AMOUNT]:
    'Gọi paygate thành công nhưng số tiền không hợp lệ',
  [VIEON_REQUEST_SUBS_STATUS.ADMIN_CANCEL]: 'Quản trị viên hủy',
  [VIEON_REQUEST_SUBS_STATUS.TIMEOUT]:
    'Timeout'
});
